module.exports = __webpack_public_path__ + "static/img/13.6c3d22d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/zh/13.png
// module id = HQWV
// module chunks = 0